/* ══════════════════════════════════════════════════════════════════════
   PREVIEW-COMPTE.JS — APERÇU LOCAL UNIQUEMENT. NE PAS LIVRER.

   Rejoue, sans boutique, deux choses que Shopify fait tout seul :

   1. LA PORTE. Sur une vraie boutique, /account renvoie vers
      /account/login tant que le visiteur n'est pas connecté, et le thème
      n'a rien à faire : {{ routes.account_url }} suffit. Ici, les pages
      sont des fichiers, personne ne redirige — d'où la garde en ligne
      dans le <head> de chaque page, qui doit s'exécuter AVANT le premier
      rendu pour ne pas laisser voir un compte d'une image.

   2. LES ADRESSES. Sur la boutique, {% form 'customer_address' %} crée,
      modifie et supprime ; Shopify garde la liste. Ici on la garde dans
      localStorage, le temps de voir le comportement.

   Rien de ce fichier ne part dans le zip : build.sh ne package que
   theme/. Aucune de ces lignes n'a d'équivalent à écrire en Liquid.

   Une règle tenue : AUCUNE phrase destinée à l'écran n'est écrite ici.
   Les mots viennent de la page — la carte modèle est recopiée telle
   quelle, les libellés sont lus dans des attributs data-txt-*. Ce qui
   est fabriqué en JS échappe au traducteur.
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var SESSION  = 'preview-compte';
  var ADRESSES = 'preview-adresses';

  function connecte() {
    try { return localStorage.getItem(SESSION) === '1'; } catch (e) { return false; }
  }
  function ouvrirSession()  { try { localStorage.setItem(SESSION, '1'); } catch (e) {} }
  function fermerSession()  { try { localStorage.removeItem(SESSION);  } catch (e) {} }

  function lire() {
    try { return JSON.parse(localStorage.getItem(ADRESSES) || 'null'); }
    catch (e) { return null; }
  }
  function ecrire(liste) {
    try { localStorage.setItem(ADRESSES, JSON.stringify(liste)); } catch (e) {}
  }

  /* ── L'icône de la barre ────────────────────────────────────────────
     Connecté, elle mène au compte ; sinon à la connexion. C'est le
     comportement de Shopify, pas une invention : personne n'arrive sur
     « mon compte » avant d'en avoir un. */
  function porte() {
    var lien = document.querySelector('.hdr-right a[href^="compte"]');
    if (lien) lien.setAttribute('href', connecte() ? 'compte.html' : 'compte-connexion.html');
  }

  /* ── Connexion, création, déconnexion ───────────────────────────────
     Aucun mot de passe n'est vérifié : il n'y a pas de serveur. On note
     seulement qu'une session existe, ce qui suffit à montrer les deux
     états du site. */
  function formulaires() {
    ['main-login', 'main-register'].forEach(function (nom) {
      var section = document.querySelector('[data-section="' + nom + '"]');
      if (!section) return;
      var form = section.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        ouvrirSession();
        location.href = 'compte.html';
      });
    });

    var sortie = document.querySelector('[data-deconnexion]');
    if (sortie) {
      sortie.addEventListener('click', function () { fermerSession(); });
    }
  }

  /* ── Adresses ───────────────────────────────────────────────────────
     Une carte modèle est prélevée dans la page, puis recopiée pour
     chaque adresse. Les valeurs vivent dans des attributs ; le texte
     visible n'en est que le rendu. */
  function adresses() {
    var liste = document.querySelector('[data-adr-liste]');
    var form  = document.querySelector('[data-adr-form]');
    if (!liste || !form) return;

    var CHAMPS = ['prenom', 'nom', 'rue', 'cp', 'ville', 'pays', 'tel'];
    var modele = liste.querySelector('[data-adr]');
    if (!modele) return;
    modele = modele.cloneNode(true);

    function depuisDOM() {
      return [].map.call(liste.querySelectorAll('[data-adr]'), function (el) {
        var a = {};
        CHAMPS.forEach(function (c) { a[c] = el.dataset[c] || ''; });
        a.defaut = el.dataset.defaut === '1';
        return a;
      });
    }

    var carnet = lire() || depuisDOM();

    /* Quatre lignes, comme une enveloppe : identité, rue, code et ville,
       pays. Une ligne vide disparaît au lieu de laisser un trou. */
    function lignes(a) {
      return [
        [a.prenom, a.nom].filter(Boolean).join(' '),
        a.rue,
        [a.cp, a.ville].filter(Boolean).join(' '),
        a.pays
      ].filter(Boolean);
    }

    function dessiner() {
      liste.textContent = '';
      carnet.forEach(function (a, rang) {
        var carte = modele.cloneNode(true);
        carte.dataset.rang = rang;
        CHAMPS.forEach(function (c) { carte.dataset[c] = a[c] || ''; });
        carte.dataset.defaut = a.defaut ? '1' : '';

        var tag = carte.querySelector('[data-adr-tag]');
        if (tag && !a.defaut) tag.remove();

        var corps = carte.querySelector('[data-adr-lignes]');
        corps.textContent = '';
        lignes(a).forEach(function (l, i) {
          if (i) corps.appendChild(document.createElement('br'));
          corps.appendChild(document.createTextNode(l));
        });

        liste.appendChild(carte);
      });
    }

    /* Le formulaire sert deux fois : ajouter, et modifier. C'est le même
       objet à l'écran — ouvrir une seconde boîte pour les mêmes sept
       champs n'aurait rien appris à personne. data-edite porte le rang
       en cours d'édition, absent quand on ajoute. */
    var envoi = form.querySelector('[type="submit"] span') ||
                form.querySelector('[type="submit"]');
    var bouton = form.querySelector('[type="submit"]');
    var coche  = form.querySelector('#adr-defaut');

    function champ(nom) { return form.querySelector('#adr-' + nom); }

    function remplir(a) {
      CHAMPS.forEach(function (c) {
        var el = champ(c);
        if (el) el.value = a ? (a[c] || '') : '';
      });
      if (coche) coche.checked = !!(a && a.defaut);
    }

    function mode(rang) {
      if (rang === null) {
        delete form.dataset.edite;
        if (envoi && bouton.dataset.txtAjout) envoi.textContent = bouton.dataset.txtAjout;
      } else {
        form.dataset.edite = rang;
        if (envoi && bouton.dataset.txtEdition) envoi.textContent = bouton.dataset.txtEdition;
      }
    }

    /* Annuler ou replier le formulaire le remet à zéro : le rouvrir plus
       tard ne doit pas ressortir l'adresse qu'on éditait il y a dix
       minutes. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-adr-toggle]')) return;
      if (form.hidden) { remplir(null); mode(null); }
    });

    liste.addEventListener('click', function (e) {
      var carte = e.target.closest('[data-adr]');
      if (!carte) return;
      var rang = Number(carte.dataset.rang);

      if (e.target.closest('[data-adr-modifier]')) {
        remplir(carnet[rang]);
        mode(rang);
        form.hidden = false;
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var premier = champ('prenom');
        if (premier) premier.focus();
        return;
      }

      if (e.target.closest('[data-adr-supprimer]')) {
        var question = liste.dataset.txtSuppr;
        if (question && !confirm(question)) return;
        carnet.splice(rang, 1);
        /* Il faut toujours une adresse par défaut : si c'est elle qu'on
           vient d'effacer, la première reprend le rôle. */
        if (carnet.length && !carnet.some(function (a) { return a.defaut; })) {
          carnet[0].defaut = true;
        }
        ecrire(carnet);
        dessiner();
        if (!form.hidden) { form.hidden = true; remplir(null); mode(null); }
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var a = {};
      CHAMPS.forEach(function (c) {
        var el = champ(c);
        a[c] = el ? el.value.trim() : '';
      });
      a.defaut = !!(coche && coche.checked);
      if (!lignes(a).length) return;          // rien de saisi

      if (a.defaut) carnet.forEach(function (o) { o.defaut = false; });

      if ('edite' in form.dataset) carnet[Number(form.dataset.edite)] = a;
      else carnet.push(a);

      if (!carnet.some(function (o) { return o.defaut; })) carnet[0].defaut = true;

      ecrire(carnet);
      dessiner();
      form.hidden = true;
      remplir(null);
      mode(null);
    });

    dessiner();
  }

  function demarrer() { porte(); formulaires(); adresses(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
